var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { isAssignmentCell } from '../tableConfig';
import { formatDates } from '../../../../../utils/formatDates';
import { parseISO } from 'date-fns';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1eub232" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
export var DateCell = function (_a) {
    var original = _a.row.original;
    if (!isAssignmentCell(original))
        return null;
    var startDate = original.startDate, endDate = original.endDate;
    return _jsx(ScCell, { children: formatDates(parseISO(startDate), parseISO(endDate)) }, void 0);
};
var templateObject_1;
